<template>
  <ContentTabs :config="config" />
</template>

<script>
import ContentTabs from "../../components/ContentTabs/ContentTabs.vue";

export default {
  name: "app",
  components: {
    ContentTabs
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
